export const environment = {
  production: false,
  apiUrl: "https://gsignature-staging-01.lm.r.appspot.com",
  restApiUrl: "https://gsignature-staging-01.lm.r.appspot.com",
  digitalCardApiUrl:
    "https://gsignature-digital-card-83737666361.europe-west1.run.app",
  stripeKey:
    "pk_test_51I89sXGqpDTuSLudECZFXaAJASwoiTJuN52v8hY60zxLRIC9ry8zzDwF2mEfwAYyISdpEGzv80RrJx1ALIP2voBs00gxPB4By8",
  firebaseConfig: {
    apiKey: "AIzaSyB47K_Q6VHecCgqlSf7KAYIWIlXPGtWx-E",
    authDomain: "gsignature-staging-01.web.app",
    projectId: "gsignature-staging-01",
    storageBucket: "gsignature-staging-01.firebasestorage.app",
    messagingSenderId: "83737666361",
    appId: "1:83737666361:web:92f392e3f5d2a60400fee8",
  },
};
